import { useDriverTheme } from "@/hooks/useDriverTheme";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

 const Toaster = ({ ...props }: ToasterProps) => {
   const { isDark } = useDriverTheme();

   return (
    <Sonner
       theme={isDark ? 'dark' : 'light'}
      className="toaster group"
      position="top-center"
      duration={2000}
      toastOptions={{
        style: { marginTop: 'calc(env(safe-area-inset-top, 0px) + 8px)' },
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
